import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = localStorage.getItem("ash_admin_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_clarity-checkup-1/artifacts/6al1on53_ASH-logo.png";
export const LOGO_ICON =
    "https://customer-assets.emergentagent.com/job_clarity-checkup-1/artifacts/94zh8rso_ASH_logo_icon.png";
